import { useEffect } from 'react';

const SEO = ({ 
  title = 'Trademark Registration Services | Protect Your Brand',
  description = 'Professional trademark registration services with licensed USPTO attorneys. Fast filing, transparent pricing, 98% success rate.',
  keywords = 'trademark registration, trademark filing, brand protection, USPTO, trademark attorney',
  canonical = ''
}) => {
  useEffect(() => {
    document.title = title;

    const setMeta = (attr, attrVal, content) => {
      let el = document.querySelector(`meta[${attr}="${attrVal}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const siteUrl = window.location.origin;
    const fullUrl = canonical ? `${siteUrl}${canonical}` : window.location.href;

    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', fullUrl);
    setMeta('property', 'og:type', 'website');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', fullUrl);
  }, [title, description, keywords, canonical]);

  return null;
};

export default SEO;
